import SearchInput from '../../../../Utils/SearchInput';
import { Button } from 'antd';
import { useApprovalCount, useUpdateUserStatus } from '../../../../Hooks/TT_ELD/NewAccounts';
import AcceptedListTable from './CustomTable/AcceptedListTable';

type AcceptedProps = {
  companyName: string;
  setCompanyName: (value: string) => void;
  username: string;
  setUsername: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  skip: string;
  setSkip: (value: string) => void;
};

const AcceptedList = ({
  companyName,
  setCompanyName,
  username,
  setUsername,
  email,
  setEmail,
  skip,
  setSkip,
}: AcceptedProps) => {
  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      companyName: setCompanyName,
      email: setEmail,
      username: setUsername,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip('1');
    }
  };

  const { data, refetch, isLoading, isFetching } = useUpdateUserStatus(
    username,
    email,
    companyName,
    skip,
    'accepted',
  );
  const count = useApprovalCount();

  const onChange = (query: any) => {
    setSkip(query.current);
  };
  const updates = () => {
    refetch();
    count.refetch();
  };
  return (
    <div className="mainPage">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 10,
        }}
      >
        <SearchInput
          value={companyName}
          onDebounceChange={(event: string) => handleChange(event, 'companyName')}
          placeholder={'Search by company'}
        />
        <SearchInput
          value={username}
          onDebounceChange={(event: string) => handleChange(event, 'username')}
          placeholder={'Search by name'}
        />
        <SearchInput
          value={email}
          onDebounceChange={(event: string) => handleChange(event, 'email')}
          placeholder={'Search by email'}
        />
        <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={updates}>
          Refresh
        </Button>
      </div>

      <AcceptedListTable
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={updates}
        skip={skip}
      />
    </div>
  );
};

export default AcceptedList;
